import SyncConstant from '../constant/SyncConstant';

export default {
    /**
     * sync action log
     * @param {Object} [options]
     * @param {string[]} [options.onlyActionTypes] — if set, only these action_type rows are sent (avoids pulling unrelated pending logs e.g. place_order).
     * @returns {{type: string, onlyActionTypes?: string[]}}
     */
    syncActionLog: (options = {}) => {
        const action = {
            type: SyncConstant.SYNC_ACTION_LOG
        };
        if (options.onlyActionTypes && options.onlyActionTypes.length) {
            action.onlyActionTypes = options.onlyActionTypes;
        }
        return action;
    },

    /**
     * sync action log success
     * @returns {{type: string}}
     */
    syncActionLogSuccess: () => {
        return {
            type: SyncConstant.SYNC_ACTION_LOG_SUCCESS
        }
    }
}


// WEBPACK FOOTER //
// ./src/view/action/ActionLogAction.js